import {Injectable} from '@angular/core';
import {HttpService} from '../../_service/http.service';
import {MetersValuesModel} from './meters-values-model';

@Injectable()
export class MeterValueService {

  constructor(private http: HttpService) { }

  async getMetersValuesByAccount(accountNumber: string, alias: string): Promise<MetersValuesModel> {

    const sb = [];
    sb.push('rest/site/' + alias + '/getMetersValuesForWidget');
    sb.push('?accountNumber=' + accountNumber);

    let response = null;

    await this.http.getData(sb.join(''), 'send-meter-values')
      .then((data) => {
        console.log('Received data in getMetersValues is: ', data);
        response = new MetersValuesModel(data);

      }, (error) => {
        console.warn('getMetersValues ERROR:', error);
        throw error;
      });

    return response;
  }

  async postMetersValuesForWidget(realtyId, attemptsNumber, accountNumber, postValues, alias) {

    const sb = [];
    sb.push('rest/site/' + alias + '/postMetersValuesForWidget?realtyId=');
    sb.push(realtyId);
    sb.push('&accountNumber=');
    sb.push(accountNumber);
    sb.push('&errorCounter=');
    sb.push(attemptsNumber);

    let response = null;

    await this.http.postData(sb.join(''), postValues)
      .then((data) => {
        console.log('Post meeters answer: ', data);
        response = data;
      }, (error) => {
        console.warn('Post meeters  ERROR:', error);
        throw error;
      });

    return response;
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/send-values-widget/meter-value.service.ts